import React from "react";
import { Mail, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function KontaktCta() {
  return <section data-section-id="225641" id="jetzt-kontakt-aufnehmen" className="py-24 relative overflow-hidden bg-[rgba(2,110,108,1)] sm:py-32">
      <div className="absolute inset-0 bg-[url(https://stable-sturgeon.10web.cloud/wp-content/uploads/2026/05/skin_texture_background.png)] bg-cover bg-center opacity-20 pointer-events-none" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-white/5 via-transparent to-transparent pointer-events-none" />
      
      <div className="mx-auto max-w-7xl px-6 lg:px-8 relative z-10">
        <div className="mx-auto max-w-3xl text-center rounded-lg bg-white/5 px-6 py-16 ring-1 ring-inset ring-white/10 backdrop-blur-sm !border-solid !border-1 !text-[rgba(249,255,254,1)] !border-[rgba(251,255,255,1)] sm:p-20">
          <h2 className="font-bold tracking-tight text-white font-default !text-5xl">Sichere Dir Deine BEWEI FACE Probebehandlung:</h2>
          <p className="mx-auto mt-6 max-w-xl leading-8 text-white/90 !font-sans !not-italic !text-5xl !font-extrabold">FÜR NUR 49 EURO</p>
          <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
            <div className="mt-4 flex justify-center w-full">
    <div className="zeeg-inline-widget w-full max-w-2xl" id="zeeg-embed-bodyconcept-by-linda-bewei-face" style={{
              minWidth: "320px",
              minHeight: "780px"
            }}></div>
    <script type="text/javascript" src="https://assets.zeeg.me/embed.min.js" data-user="bodyconcept-by-linda" data-event-type="bewei-face" data-redirect-parent="true" async></script>
</div>
          </div>
        </div>
      </div>
    </section>;
}